import { verifyItems } from "@/mocks/tracking";

const statusStyle: Record<string, { label: string; cls: string; bar: string; width: string }> = {
  待核: { label: "待核", cls: "bg-soft text-muted", bar: "bg-faint", width: "w-1/3" },
  存疑: { label: "存疑", cls: "bg-gold-soft text-gold-text", bar: "bg-gold", width: "w-2/3" },
  已证: { label: "已证", cls: "bg-mark-soft text-mark-text", bar: "bg-mark", width: "w-full" },
};

export default function VerifySection() {
  return (
    <section id="verify" className="w-full border-b border-line bg-cream">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_0.92fr] lg:gap-12">
          {/* 左侧：说明 + 清单 */}
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-gold-text">
              Verify Desk
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink md:text-3xl">
              求证台 · 流出信息核对
            </h2>
            <p className="mt-2 max-w-lg text-sm leading-relaxed text-muted">
              黑料之所以让人上头，常因「看起来像真的」。求证台不急着下结论，把每条近期流出按
              待核 / 存疑 / 已证 分档，给你一个可回查的对账入口。
            </p>

            <div className="mt-6 flex items-center gap-2 rounded-lg border border-line bg-paper px-4 py-3">
              <i className="ri-error-warning-line text-lg text-gold"></i>
              <p className="text-xs leading-relaxed text-muted md:text-sm">
                本页内容均为程序化占位示例，用于演示页面结构与交互；真实站点的求证流程以人工审核为准。
              </p>
            </div>

            <div className="mt-6 flex items-center gap-2 text-xs text-faint">
              <i className="ri-checkbox-circle-line text-sm"></i>
              共收录 36 条求证记录，24h 内新增 5 条
            </div>
          </div>

          {/* 右侧：进度清单 */}
          <ol className="space-y-3">
            {verifyItems.map((v) => {
              const s = statusStyle[v.status];
              return (
                <li
                  key={v.title}
                  className="rounded-lg border border-line bg-card px-4 py-4 transition-colors hover:bg-cream"
                >
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="text-sm font-semibold text-ink md:text-base">{v.title}</h3>
                    <span
                      className={`shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${s.cls}`}
                    >
                      {s.label}
                    </span>
                  </div>
                  <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-soft">
                    <div className={`h-full rounded-full ${s.bar} ${s.width}`}></div>
                  </div>
                  <p className="mt-2 text-xs text-faint">
                    <span className="text-muted">{v.progress}</span> · {v.note}
                  </p>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}